{
  "metadata": {
    "id": "oc-2-light",
    "name": "OC-2",
    "description": "Портировано из темы «OC-2» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "oc-2.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/oc-2.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.449,
      "paletteMaxS": 0.514,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.9,
      "syntaxVsTextMinDeltaE": 29.6,
      "chartsMinDeltaE": 22.5,
      "textSeparationDeltaE": 23.6,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#90932b",
      "hover": "#828427",
      "active": "#767923",
      "foreground": "#000000",
      "muted": "#90932b80",
      "emphasis": "#90932b"
    },
    "surface": {
      "background": "#f7f7f7",
      "foreground": "#171311",
      "muted": "#cbc9c9",
      "mutedForeground": "#464646",
      "elevated": "#b4b3b2",
      "elevatedForeground": "#171311",
      "raised": "#9a9897",
      "raisedForeground": "#171311",
      "overlay": "#f7f7f733",
      "subtle": "#e0e0df"
    },
    "interactive": {
      "border": "#93918f",
      "borderHover": "#b8b7b7",
      "borderFocus": "#90932b",
      "selection": "#17131124",
      "selectionForeground": "#171311",
      "focus": "#90932b59",
      "focusRing": "#90932b47",
      "cursor": "#171717",
      "hover": "#17131117",
      "active": "#17131124"
    },
    "status": {
      "error": "#dc1f03",
      "errorForeground": "#ffffff",
      "errorBackground": "#dc1f031a",
      "errorBorder": "#dc1f0359",
      "warning": "#826e00",
      "warningForeground": "#ffffff",
      "warningBackground": "#826e001a",
      "warningBorder": "#826e0059",
      "success": "#0c8303",
      "successForeground": "#ffffff",
      "successBackground": "#0c83031a",
      "successBorder": "#0c830359",
      "info": "#a451ab",
      "infoForeground": "#ffffff",
      "infoBackground": "#a451ab1a",
      "infoBorder": "#a451ab59"
    },
    "pr": {
      "open": "#0c8303",
      "draft": "#545454",
      "blocked": "#826e00",
      "merged": "#90932b",
      "closed": "#dc1f03"
    },
    "syntax": {
      "base": {
        "background": "#cbc9c9",
        "foreground": "#171311",
        "comment": "#545454",
        "keyword": "#793b7e",
        "string": "#26593b",
        "number": "#005e61",
        "function": "#793b7e",
        "variable": "#171311",
        "type": "#665200",
        "operator": "#505030"
      },
      "tokens": {
        "commentDoc": "#545454",
        "stringEscape": "#505030",
        "keywordImport": "#793b7e",
        "storageModifier": "#793b7e",
        "functionCall": "#793b7e",
        "method": "#793b7e",
        "variableProperty": "#793b7e",
        "variableOther": "#171311",
        "variableGlobal": "#005e61",
        "variableLocal": "#505030",
        "parameter": "#171311",
        "constant": "#005e61",
        "class": "#665200",
        "className": "#665200",
        "interface": "#665200",
        "struct": "#665200",
        "enum": "#665200",
        "typeParameter": "#665200",
        "namespace": "#665200",
        "module": "#793b7e",
        "tag": "#793b7e",
        "jsxTag": "#793b7e",
        "tagAttribute": "#793b7e",
        "tagAttributeValue": "#26593b",
        "boolean": "#005e61",
        "decorator": "#793b7e",
        "label": "#793b7e",
        "regexp": "#26593b"
      }
    },
    "charts": {
      "series": [
        "#90932b",
        "#a451ab",
        "#0c8303",
        "#8cab00",
        "#dc1f03"
      ]
    },
    "chat": {
      "background": "#f7f7f7",
      "userMessage": "#171311",
      "userMessageBackground": "#b4b3b2",
      "assistantMessage": "#171311",
      "assistantMessageBackground": "#cbc9c9",
      "timestamp": "#545454",
      "divider": "#93918f",
      "typing": "#545454"
    },
    "loading": {
      "spinner": "#90932b",
      "spinnerTrack": "#cbc9c9",
      "skeleton": "#cbc9c9",
      "shimmer": "#c0bebe"
    },
    "tools": {
      "background": "#cbc9c9",
      "border": "#93918f",
      "headerHover": "#c2c0c0",
      "icon": "#717322",
      "title": "#171311",
      "description": "#545454",
      "edit": {
        "added": "#0c8303",
        "addedBackground": "#0c83031a",
        "removed": "#dc1f03",
        "removedBackground": "#dc1f031a",
        "modified": "#a451ab",
        "modifiedBackground": "#a451ab1a",
        "lineNumber": "#545454"
      }
    },
    "markdown": {
      "heading1": "#171311",
      "heading2": "#171311",
      "heading3": "#171311",
      "heading4": "#171311",
      "link": "#717322",
      "linkHover": "#727422",
      "inlineCode": "#26593b",
      "inlineCodeBackground": "#cbc9c9",
      "blockquote": "#545454",
      "blockquoteBorder": "#93918f",
      "listMarker": "#8c8f2a",
      "bold": "#171311",
      "italic": "#171311e6",
      "strikethrough": "#545454",
      "hr": "#93918f"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#b76957",
        "foreground": "#000000",
        "contrast": 5.17
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d0a194",
        "foreground": "#000000",
        "contrast": 9.21
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c69154",
        "foreground": "#000000",
        "contrast": 7.58
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#afcb5d",
        "foreground": "#000000",
        "contrast": 11.52
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#bdd499",
        "foreground": "#000000",
        "contrast": 13.04
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5ec959",
        "foreground": "#000000",
        "contrast": 9.97
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#61bc7a",
        "foreground": "#000000",
        "contrast": 8.98
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#5fc6af",
        "foreground": "#000000",
        "contrast": 10.18
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#58b0c7",
        "foreground": "#000000",
        "contrast": 8.45
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#5885b6",
        "foreground": "#000000",
        "contrast": 5.45
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5365b3",
        "foreground": "#ffffff",
        "contrast": 5.41
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#664bbe",
        "foreground": "#ffffff",
        "contrast": 6.33
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a574cd",
        "foreground": "#000000",
        "contrast": 5.98
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c152c3",
        "foreground": "#000000",
        "contrast": 5.26
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#d094c4",
        "foreground": "#000000",
        "contrast": 8.72
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c34f7a",
        "foreground": "#000000",
        "contrast": 4.72
      }
    ]
  }
}
